import React from 'react';
import AccessGate from './controllers/AccessGate';
import FormProvider from './controllers/FormProvider';
import SetupLayout from '../../shared/ui/SetupLayout';
import Header from './presenters/Header';
import Body from './presenters/Body';

const CreateNewConfigPage = ({ className }) => {
  return (
    <AccessGate>
      <FormProvider>
        <SetupLayout
          className={className}
          header={<Header />}
          body={<Body />}
        />
      </FormProvider>
    </AccessGate>
  );
};

export default CreateNewConfigPage;
